export enum ContainersActions {
    RELOAD_DATA = "reloadContainers",
    SET_CONTAINERS="setContainers",
    TOGGLE_PANEL="togglePanel",
    TOGGLE_MODAL = "toggleModal",
    SET_FORM_TYPE="setFormType",
    CLEAR ="Clear"
  }